'use strict';

var returnAttributes = function returnAttributes(attributes) {
  var newAttributesObject = Object.keys(attributes).reduce(function (previousValue, currentElement) {
    if (attributes[currentElement]) {
      previousValue[currentElement] = attributes[currentElement];
    }
    return previousValue;
  }, {});
  return newAttributesObject;
};
var hasSameOrigin = function hasSameOrigin(url, location) {
  try {
    return new URL(url).origin !== location.origin;
  } catch (err) {
    return false;
  }
};
var isExternalLink = function isExternalLink(url, location) {
  return (url === null || url === void 0 ? void 0 : url.startsWith('http://')) || (url === null || url === void 0 ? void 0 : url.startsWith('https://')) || (url === null || url === void 0 ? void 0 : url.startsWith('//')) || hasSameOrigin(url, location);
};

exports.isExternalLink = isExternalLink;
exports.returnAttributes = returnAttributes;
//# sourceMappingURL=index.js.map
